var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6162 3.74479C12.584 3.66674 12.5362 3.59358 12.473 3.52999L12.4702 3.52716C12.3496 3.40735 12.1835 3.33331 12.0002 3.33331H6.00016C5.63197 3.33331 5.3335 3.63179 5.3335 3.99998C5.3335 4.36817 5.63197 4.66665 6.00016 4.66665H10.3907L3.52876 11.5286C3.26841 11.7889 3.26841 12.211 3.52876 12.4714C3.78911 12.7317 4.21122 12.7317 4.47157 12.4714L11.3335 5.60946V9.99998C11.3335 10.3682 11.632 10.6666 12.0002 10.6666C12.3684 10.6666 12.6668 10.3682 12.6668 9.99998V4.00044L12.6668 3.99798C12.6666 3.90832 12.6486 3.82282 12.6162 3.74479Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLink);
export default __webpack_public_path__ + "static/media/arrow-link.89eb08532965db2db282fcc49a51b24c.svg";
export { ForwardRef as ReactComponent };